// NOTE: this is mainly used for debugging purposes and rare ERB flexicon usages. best to use these methods directly in react code.
import { Controller } from '@hotwired/stimulus';

import { thumbhashToAverageRGBA, thumbhashToDataURL } from '../lib/thumbdata';

export default class extends Controller {
  static values = { thumbhash: String };

  static targets = ['averageRGB', 'averageRGBA', 'dataURL', 'tint'];

  connect() {
    if (this.hasDataURLTarget) {
      this.dataURLTarget.style.backgroundImage = `url(${thumbhashToDataURL(this.thumbhashValue)})`;
    }

    if (this.hasAverageRGBTarget || this.hasAverageRGBATarget || this.hasTintTarget) {
      const averageRGBA = thumbhashToAverageRGBA(this.thumbhashValue);

      if (this.hasAverageRGBTarget) {
        this.averageRGBTarget.style.backgroundColor = `rgb(${averageRGBA.r * 255}, ${averageRGBA.g * 255}, ${averageRGBA.b * 255})`;
      }

      if (this.hasAverageRGBATarget) {
        this.averageRGBATarget.style.backgroundColor = `rgba(${averageRGBA.r * 255}, ${averageRGBA.g * 255}, ${averageRGBA.b * 255}, ${averageRGBA.a})`;
      }

      if (this.hasTintTarget) {
        this.tintTarget.style.backgroundColor = `rgba(${averageRGBA.r * 255}, ${averageRGBA.g * 255}, ${averageRGBA.b * 255}, 0.5)`;
      }
    }
  }
}
